// 初期表示
export const PAGE_INIT = "corp/csr/evaluation/PAGE_INIT";
// 詳細を選択された項目に更新する
export const DETAILS_UPDATE = "corp/csr/evaluation/DETAILS_UPDATE";
